import { useCallback, useEffect, useState } from 'react';
import { CrossMarketStatus, fetchCrossMarketStatus } from '../services/crossMarketApi';

export function useCrossMarketStatus() {
  const [data, setData] = useState<CrossMarketStatus | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(await fetchCrossMarketStatus());
    } catch (err) {
      setError(err instanceof Error ? err.message : '시스템 현황 조회 실패');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}
